/* src/app/shared/components/headers/main-header/main-header.component.scss */
.header-container {
  height: 100vh;
  background: #FFF;
  display: flex;
  flex-direction: column;
}
.open-menu {
  width: 225px;
}
.closed-menu {
  width: 60px;
}
.log-button-select-container {
  display: flex;
  align-items: center;
}
.log-button-select-container-large {
  padding: 25px;
  justify-content: space-between;
}
.log-button-select-container-small {
  padding: 25px;
  justify-content: center;
}
.logo {
  width: auto;
  height: 40px;
  cursor: pointer;
}
.select-container {
  display: flex;
  padding: 10px 25px;
}
.width-100 {
  width: 100%;
}
.menu-list-container {
  display: flex;
  flex-direction: column;
}
.menu-item {
  cursor: pointer;
}
.menu-item-wrapper {
  position: relative;
}
.menu-item-wrapper:before {
  content: "";
  position: absolute;
  width: 4px;
  height: 100%;
  bottom: 0;
  left: 0;
  background-color: #F03C64;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  visibility: hidden;
  transform: scale(0);
  transition: all 0.3s ease-in-out;
}
.menu-item-wrapper:hover:before {
  content: "";
  position: absolute;
  width: 4px;
  height: 100%;
  bottom: 0;
  left: 0;
  background-color: #F03C64;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  visibility: visible;
  transform: scale(1);
}
.label-and-icon-container {
  display: flex;
  align-items: center;
  font: 400 14px FranceTV Brown;
  color: #6B90B3;
}
.label-and-icon-container:hover {
  font: 700 14px FranceTV Brown;
  color: #244666;
}
.label-and-icon-container-large {
  padding: 10px 25px;
}
.label-and-icon-container-small {
  padding: 10px;
  justify-content: center;
}
.menu-icon {
  width: 20px;
}
.margin-right-10 {
  margin-right: 10px;
}
.menu-label {
  position: relative;
  padding-bottom: 10px;
  padding-top: 10px;
}
.menu-item-active {
  position: relative;
  font: 700 14px FranceTV Brown;
  color: #244666;
}
.menu-item-active:before {
  content: "";
  position: absolute;
  width: 4px;
  height: 100%;
  bottom: 0;
  left: 0;
  background-color: #F03C64;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  animation: 0.3s line ease-in-out;
}
.menu-section-separator {
  height: 1px;
  background-color: #DFEBF7;
}
.user-container {
  display: flex;
  align-items: center;
  justify-content: center;
  font: 400 14px FranceTV Brown;
  color: #6B90B3;
  margin-top: auto;
}
.user-container-small {
  padding-bottom: 10px;
}
.user-container-large {
  padding: 10px 25px;
}
.trigram {
  margin-right: 10px;
}
.user-icon {
  font-size: 20px;
  height: 20px;
  width: 20px;
  margin-right: 10px;
}
.logout-icon {
  cursor: pointer;
  font-size: 20px;
  height: 20px;
  width: 20px;
  margin-left: 10px;
}
@keyframes line {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}
.tv-ns-select-option {
  color: #244666 !important;
  background-color: white;
  box-shadow:
    0px 2px 1px -1px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14),
    0px 1px 3px 0px rgba(0, 0, 0, 0.12);
}
/*# sourceMappingURL=main-header.component.css.map */
